import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import {
  WarmTransferDestination,
  WarmTransferDestinationType,
} from '@api/generated/graphql';

export const getWarmTransferDestinationQuery = graphql(`
  query GetWarmTransferDestination($sid: String!) {
    warmTransferDestination(sid: $sid) {
      destination
      type
    }
  }
`);

export type GetWarmTransferDestinationResult = {
  destination: WarmTransferDestination | null;
  destinationType: WarmTransferDestinationType | null;
};

/**
 * Fetches the warm transfer destination for a given conversation SID.
 */
export const getWarmTransferDestination = async (
  sid: string,
): Promise<GetWarmTransferDestinationResult> => {
  const { data, error } = await getClient().query({
    query: getWarmTransferDestinationQuery,
    variables: { sid },
    fetchPolicy: 'network-only',
  });

  if (error) {
    throw new Error(error.message);
  }

  const warmTransferDestination = data?.warmTransferDestination ?? null;

  return {
    destination: warmTransferDestination,
    destinationType: warmTransferDestination?.type ?? null,
  };
};
